export const relationshipStatusArray = {
  married: "Married",
  divorced: "Divorced",
  separated: "Separated",
  unmarried: "Unmarried",
  domestic_partnership: "Domestic Partnership",
} as const;

export type RelationshipStatus = keyof typeof relationshipStatusArray;
